import { jsx as _jsx } from "react/jsx-runtime";
var LastPage = function LastPage(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M19 19a1 1 0 1 0 2 0V5a1 1 0 1 0-2 0v14Zm-4.135-6H4a1 1 0 0 1 0-2h10.865l-3.633-4.36a1 1 0 1 1 1.536-1.28l5 6c.027.032.045.068.063.104a1.103 1.103 0 0 0 .05.091c.017.026.034.053.046.083a.985.985 0 0 1 .072.358L18 12l-.001.004a.985.985 0 0 1-.072.358c-.012.03-.029.057-.046.083a.836.836 0 0 0-.025.041c-.01.016-.017.033-.026.05a.512.512 0 0 1-.062.104l-5 6a1 1 0 1 1-1.536-1.28L14.865 13Z",
      fill: color
    })
  });
};
export default LastPage;